import { NavigationItem } from '../models/interfaces/navigation';
import { SoctripIcons } from './soctrip-icon.enum';
import { AppRoutes } from '../enum/routes.enum';
import { environment } from 'src/environments/environment';
import { PermissionCode } from './permission-code';
export const MenuSidebar: NavigationItem[] = [
  {
    path: 'dashboard',
    title: 'dashboard',
    icon: SoctripIcons.BAR_CHART_SQUARE_01,
    permission: [PermissionCode.DASHBOARD_ACCESS],
    visible: true,
  },
  {
    path: 'agency-management',
    title: 'agency-management',
    icon: SoctripIcons.USER_CHECK_01,
    permission: [PermissionCode.AGENCY_MANAGEMENT_ACCESS],
    visible: true,
  },
  {
    path: AppRoutes.CAR_MANAGEMENT,
    title: AppRoutes.CAR_MANAGEMENT,
    icon: 'sctr-icon-car',
    permission: [PermissionCode.MANAGEMENT_ACCESS],
    visible: environment.CAR_MANAGEMENT_VISIBLE,
  },
  {
    path: AppRoutes.PROMOTION_MANAGEMENT,
    title: AppRoutes.PROMOTION_MANAGEMENT,
    icon: 'sctr-icon-percent-03',
    permission: ['PROMOTION_ACCESS'],
    visible: environment.PROMOTION_MANAGEMENT_VISIBLE,
  },
  {
    path: AppRoutes.ROUTE_MANAGEMENT,
    title: AppRoutes.ROUTE_MANAGEMENT,
    icon: 'sctr-icon-route',
    permission: [PermissionCode.ROUTE_MANAGEMENT_ACCESS],
    visible: environment.ROUTE_MANAGEMENT_VISIBLE,
  },
  {
    path: 'booking-helpdesk',
    title: 'booking-helpdesk',
    icon: SoctripIcons.FILE_SEARCH_02,
    permission: [PermissionCode.BOOKING_HELPDESK_ACCESS],
    visible: true,
  },
  {
    path: `${AppRoutes.REFUND_MANAGEMENT}`,
    title: 'refund-management',
    icon: SoctripIcons.CREDIT_CARD_REFRESH,
    permission: [PermissionCode.REFUND_MANAGEMENT_ACCESS],
    visible: true,
  },
  {
    path: `${AppRoutes.VOUCHER_MANAGEMENT}`,
    title: 'voucher-management',
    icon: SoctripIcons.TICKET_01,
    permission: [PermissionCode.VOUCHER_MANAGEMENT_ACCESS],
    visible: true,
  },
  {
    path: `${AppRoutes.AUTOMAKER_MANAGEMENT}`,
    title: 'automaker-management',
    icon: SoctripIcons.CAR_01,
    permission: [PermissionCode.AUTOMAKER_MANAGEMENT_ACCESS],
    visible: true,
  },
  {
    path: `${AppRoutes.AMENITY_MANAGEMENT}`,
    title: 'amenity-management',
    icon: SoctripIcons.TOOL_02,
    permission: [PermissionCode.AMENITY_MANAGEMENT_ACCESS],
    visible: true,
  },
  {
    path: AppRoutes.BANNER_MANAGERMENT,
    title: AppRoutes.BANNER_MANAGERMENT,
    icon: SoctripIcons.IMAGE_INDENT_LEFT,
    permission: [PermissionCode.BANNER_ACCESS],
    visible: true,
  },
  {
    path: AppRoutes.CHAT_FAQ_ASSISTANT,
    title: AppRoutes.CHAT_FAQ_ASSISTANT,
    icon: SoctripIcons.MESSAGE_QUESTION_SQUARE,
    permission: [PermissionCode.CHAT_FAQ_ACCESS],
    visible: environment.SOCCHAT_VISIBLE,
  },
  {
    path: AppRoutes.ADMIN_SUPPORT,
    title: 'soctrip-chat',
    icon: SoctripIcons.MESSAGE_CHAT_SQUARE,
    permission: [PermissionCode.CHAT_SUPPORT_ACCESS],
    visible: environment.SOCCHAT_VISIBLE,
  },
  {
    path: AppRoutes.REVIEW_MANAGEMENT,
    title: AppRoutes.REVIEW_MANAGEMENT,
    icon: SoctripIcons.ANNOTATION_HEART,
    permission: [PermissionCode.REVIEW_MANAGEMENT_VIEW],
    visible: environment.REVIEW_MANAGEMENT_VISIBLE,
  },
  {
    title: AppRoutes.CONFIGURATION,
    icon: 'sctr-icon-settings-01',
    visible: environment.CONFIGURATION_VISILE,
    permission: [
      PermissionCode.LANDING_PAGE_ACCESS,
      PermissionCode.SEAT_CAPACITY_ACCESS,
    ],
    children: [
      {
        path: AppRoutes.LANDING_PAGE_CONFIG,
        title: AppRoutes.LANDING_PAGE_CONFIG,
        icon: '',
        permission: [PermissionCode.LANDING_PAGE_ACCESS],
        visible: environment.LANDING_PAGE_VISIBLE,
      },
      // {
      //   path: 'rental-purpose',
      //   title: 'rental-purpose',
      //   permission: PermissionCode.RENTAL_PURPOSE_ACCESS,
      //   visible: true,
      // },
      // {
      //   path: 'public-holiday',
      //   title: 'public-holiday',
      //   permission: PermissionCode.PUBLIC_HOLIDAY_ACCESS,
      //   visible: true,
      // },
      {
        path: 'seat-capacity',
        title: 'seat-capacity',
        permission: [PermissionCode.SEAT_CAPACITY_ACCESS],
        visible: true,
      },
      {
        path: AppRoutes.RSS_FEED,
        title: AppRoutes.RSS_FEED,
        icon: 'sctr-icon-rss-01',
        permission: [PermissionCode.RSS_ACCESS],
        visible: true,
      },
    ],
  },
];
